var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VExpansionPanels',{attrs:{"multiple":"","flat":""}},_vm._l((_vm.vacancy.faq),function(faq){return _c('VacancyFaq',{key:faq.id,attrs:{"faq":faq,"vacancy":_vm.vacancy}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }